import React from "react";

/**
 * End-of-article navigation
 * Props:
 * - nextChapter: { href, title, imageSrc, imageAlt }
 * - more: [{ href, title, imageSrc, imageAlt }]
 * - containerWidth: Tailwind max-w-* class (default: max-w-lg)
 * - padY, padX: spacing props
 * - bgColor: background color (default: white)
 * - accentColor: link & heading color (default: #1d4ed8 → Tailwind blue-700)
 * - dividerColor: hr border color (default: gray-500 / gray-200)
 * - textColor: text color (default: gray-900)
 */
export default function EndOfStoryNav({
    nextChapter,
    more = [],
    containerWidth = "max-w-lg",
    padY = "py-10",
    padX = "px-6 sm:px-12",
    bgColor = "#ffffff",
    accentColor = "#1d4ed8", // Tailwind blue-700
    dividerColor = "#9ca3af", // gray-400/500
    textColor = "#111827", // gray-900
}) {
    return (
        <section
            className={`w-full ${padY} ${padX}`}
            style={{ backgroundColor: bgColor, color: textColor }}
        >
            <div className={`${containerWidth} mx-auto`}>
                {/* --- NEXT CHAPTER --- */}
                {nextChapter && (
                    <>
                        <hr style={{ borderColor: dividerColor }} className="border-t mb-2" />
                        <p
                            className="text-xs font-semibold mb-3"
                            style={{ color: textColor, opacity: 0.7 }}
                        >
                            Next Chapter
                        </p>

                        <a href={nextChapter.href} className="group block">
                            <div className="w-full overflow-hidden rounded">
                                <img
                                    src={nextChapter.imageSrc}
                                    alt={nextChapter.imageAlt || nextChapter.title}
                                    className="w-full aspect-[16/9] object-cover"
                                />
                            </div>
                            <span
                                className="mt-2 block font-bold text-xl group-hover:underline"
                                style={{ color: accentColor }}
                            >
                                {nextChapter.title}
                            </span>
                        </a>
                    </>
                )}

                {/* --- MORE FROM THIS EPISODE --- */}
                {more.length > 0 && (
                    <>
                        <hr style={{ borderColor: dividerColor }} className="border-t my-4" />
                        <p
                            className="text-xs font-semibold mb-3"
                            style={{ color: textColor, opacity: 0.7 }}
                        >
                            More from this episode
                        </p>

                        <ul className="space-y-4">
                            {more.map((item, i) => (
                                <li key={i}>
                                    <a href={item.href} className="group flex items-center gap-4">
                                        <img
                                            src={item.imageSrc}
                                            alt={item.imageAlt || item.title}
                                            className="w-[14rem]  object-cover rounded"
                                        />
                                        <span
                                            className="font-bold text-lg group-hover:underline"
                                            style={{ color: accentColor }}
                                        >
                                            {item.title}
                                        </span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
        </section>
    );
}
